import React, { useState } from 'react';
import { Button } from '../buttons/Button';
import { forgotPasswordAPI } from '../../../services/authAPI'
import { Input } from '../inputs/Input';
import { InputContainer } from '../inputs/InputContainers';
import { APIMessage } from '../messages/APIMessage';
import { Spinner } from "../spinner/Spinner"

/**
 * modal that accepts a user email and submits it to the API to reset forgotten password
 * api sends a link to a page to reset password
 * 
 * @param {function} setShowModal setter function from parent component so user can click buttons to close modal 
 * @returns {JSX.Element}
 * 
 * @category Components - UI 
 */
export const ForgotPasswordModal = ({setShowModal}) => {
    //set state
    const [email, setEmail] = useState("")

    const [submitError, setSubmitError] = useState(false)
    const [submitSuccessful, setSubmitSuccessful] = useState(false)

    const [showLoading, setShowLoading] = useState(false)

    //validation
    const validate = () => {

        if(!email){
            setSubmitError("Please fill in email")
            return false
        }
        
        setSubmitError("")

        return true
    }

    //submit email to API
    const handleSubmit = async() => {
        setShowLoading(true)
        
        if(!validate()){
            setShowLoading(false)

            return
        }

        const response = await forgotPasswordAPI(email)  

        
        if(!response.success){
            setSubmitError(response.message)
            
            setShowLoading(false)
            
            return
        }
        
        setSubmitSuccessful(true)
        setShowLoading(false)
    }

    return(
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">

            {/* if email submitted successful, tell user to check their email */}
            {submitSuccessful &&(
                <div className="flex flex-col bg-white p-4 rounded-lg">

                
                <div className="flex flex flex-col justify-around mt-4">
                    
                    <p className="mb-4">A link to reset your password has been emailed to you.</p>

                    <div className='self-center'>
                        <Button variant="primary" onClick={() => setShowModal(false)}>Okay</Button>
                    </div>
                </div>
            </div>
            )}

            {/*  area for user to submit their email address */}

            {!submitSuccessful && 
                (
                    <div className="flex flex-col items-center bg-white p-4 rounded-lg">
                        <p className="text-lg font-medium">Forgot password</p>
                        <p className="text-sm">Please enter your email below</p>
                            
                        <div className="flex flex-col items-center justify-around mt-4">
                                
                            <InputContainer>
                                <Input
                                    id="email"
                                    type="email"
                                    required
                                    placeholder="Your email..."
                                    onChange={(e)=> setEmail(e.target.value)}
                                    value={email}
                                />
                            </InputContainer>

                            <div>
                                <Button variant="success" onClick={() => handleSubmit()} className='mr-4'>Submit</Button>
                                <Button variant="cancel" onClick={() => setShowModal(false)}>Cancel</Button>
                            </div>

                            {/* show spinner when submitting */}
                            {showLoading ?
                            
                                <div className='mt-4'>
                                    <Spinner /> 
                                </div>

                            :  null} 

                            {/* submission error*/}
                            <APIMessage message={submitError} isError={true} />
                        </div>
                    </div>
                )
            }

        </div>
                
    )

}